import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import '../NewMatches/filtersSideBar.css'
import { Radio, Space, Checkbox } from 'antd';
import { useState } from 'react';

function FiltersSideBar({ filters, setFilters }) {
    //eslint-disable-next-line
    const [value, setValue] = useState(1);

    const onChangeRadio = (e) => {
        const value = e.target.value;
        alert('radio checked: ' + value);
        setValue(e.target.value);
    };

    // const onChangeCheckbox = (checkedValues) => {
    //     alert('checked = ', checkedValues);
    // };

    const filtersData = [
        // {
        //     sectionTitle: 'Matches',
        //     filters: [
        //         {
        //             label: 'All',
        //             value: 'all'
        //         }
        //     ],
        //     filterType: 'radio'
        // },
        {
            sectionTitle: 'Photo Settings',
            filters: [
                {
                    label: 'View to All',
                    value: 'all',
                    filterCount: 0
                },
                {
                    label: 'View to mutual Like only',
                    value: 'like',
                    filterCount: 0
                },
                {
                    label: 'View to Premium Members only',
                    value: 'premium',
                    filterCount: 0
                },{
                    label: 'View to liked and Premium Members',
                    value: 'likeAndPremium',
                    filterCount: 0
                },
            ],
            filterType: 'checkbox'
        },
        {
            sectionTitle: 'Marital Status',
            filters: [
                {
                    label: 'All',
                    value: 'all',
                    filterCount: 0
                },
                {
                    label: 'Never Married',
                    value: 'Never Married',
                    filterCount: 0
                },
                {
                    label: 'Divorced',
                    value: 'Divorced',
                    filterCount: 0
                },
                {
                    label: 'Widowed',
                    value: 'Widowed',
                    filterCount: 0
                },
            ],
            filterType: 'checkbox'
        },
        {
            sectionTitle: 'Education Level',
            filterType: 'checkbox',
            filters: [
                {
                    label: 'All',
                    value: 'all',
                    filterCount: 0
                },
                {
                    label: 'Diploma',
                    value: 'Diploma',
                    filterCount: 0
                },
                {
                    label: 'Bachelor',
                    value: 'Bachelors',
                    filterCount: 0
                },
                {
                    label: 'Master',
                    value: 'Masters',
                    filterCount: 0
                },
                {
                    label: 'Doctorate',
                    value: 'Doctorate',
                    filterCount: 0
                },
                {
                    label: 'Less than High School',
                    value: 'Less than High School',
                    filterCount: 0
                },
                {
                    label: 'High School',
                    value: 'High School',
                    filterCount: 0
                },
                {
                    label: 'Associates',
                    value: 'Associates',
                    filterCount: 0
                },
                {
                    label: 'Honours Degree',
                    value: 'Honours Degree',
                    filterCount: 0
                },
            ]
        },
        {
            sectionTitle: 'Diet',
            filterType: 'checkbox',
            filters: [
                {
                    label: 'All',
                    value: 'all',
                    filterCount: 0
                },
                {
                    label: 'Veg',
                    value: 'Veg',
                    filterCount: 0
                },
                {
                    label: 'Occasionally Veg',
                    value: 'Occasionally Veg',
                    filterCount: 0
                },{
                    label: 'Non-Veg',
                    value: 'Non-Veg',
                    filterCount: 0
                },{
                    label: 'Occasionally Non-Veg',
                    value: 'Occasionally Non-Veg',
                    filterCount: 0
                },{
                    label: 'Eggetarian',
                    value: 'Eggetarian',
                    filterCount: 0
                },{
                    label: 'Jain',
                    value: 'Jain',
                    filterCount: 0
                },{
                    label: 'Vegan',
                    value: 'Vegan',
                    filterCount: 0
                }
            ]
        },
    ]
    return (
        <>
            <Accordion defaultActiveKey={['0', '1', '2']} alwaysOpen>
                {filtersData.map((section, index) => (
                    <Accordion.Item key={index} eventKey={index.toString()}>
                        <Accordion.Header className='filter-section-header'>{section.sectionTitle}</Accordion.Header>
                        <Accordion.Body>
                            {section.filterType === 'radio' && (
                                <Radio.Group onChange={onChangeRadio} defaultValue={section.filters[0].value}>
                                    <Space direc tion="vertical">
                                        {section.filters.map((filter) => (
                                            <Radio value={filter.value}>{filter.label}</Radio>

                                        ))}
                                    </Space>
                                </Radio.Group>
                            )}
                            {section.filterType === 'checkbox' && (
                                <Checkbox.Group style={{ display: 'block', marginLeft: 0 }} options={section.filters} defaultValue={[section.filters[0].value]} onChange={(checkedValues) => {
                                    checkedValues = checkedValues.filter((value) => value !== 'all')
                                    switch (section.sectionTitle) {
                                        case 'Photo Settings':
                                            setFilters({ ...filters, ...{ photoSettings: checkedValues } })
                                            break;
                                        case 'Marital Status':
                                            setFilters({ ...filters, ...{ maritalStatus: checkedValues } })
                                            break;
                                        case 'Education Level':
                                            setFilters({ ...filters, ...{ educationLevel: checkedValues } })
                                            break;
                                        case 'Diet':
                                            setFilters({ ...filters, ...{ diet: checkedValues } })
                                            break;
                                        default:
                                            break;
                                    }
                                    console.log(filters)
                                }} />

                            )}

                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </>
    )
}

export default FiltersSideBar